// The only module permitted to touch window.localStorage (enforced in
// .eslintrc.js). Non-sensitive UI state only — see CLAUDE.md.

// Safari private mode throws on any access; a full quota throws on write.
const safely = (operation, fallback = null) => {
  try {
    return operation();
  } catch {
    return fallback;
  }
};

const localCache = {
  get(key, fallback = null) {
    if (!key) return fallback;

    const raw = safely(() => window.localStorage.getItem(key));
    if (raw === null || raw === undefined) return fallback;

    // Legacy keys hold bare strings, so an unparseable value is kept as-is.
    return safely(() => JSON.parse(raw), raw);
  },

  set(key, value) {
    if (!key) return;

    safely(() => window.localStorage.setItem(key, JSON.stringify(value)));
  },

  remove(key) {
    if (!key) return;

    safely(() => window.localStorage.removeItem(key));
  },

  removeByPrefix(prefix) {
    if (!prefix) return;

    // Collected first: removing while iterating skips entries.
    safely(() =>
      Object.keys(window.localStorage)
        .filter((key) => key.startsWith(prefix))
        .forEach((key) => window.localStorage.removeItem(key)),
    );
  },
};

export default localCache;
